import { gql } from '@apollo/client'
import * as f from '../../../components/BPMTable/BPMInputs'
import { 
    DataMapper, 
    TableFieldDescription,
    HideDeletionDisplayStrategy,
    DefaultClickStrategy, 
} from '../../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import {DirectTableQueryBuilder} from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";

const editMutator = gql`
    mutation($id: String!) {
        editDestination(id:$id) {
            destination {
                id
            }
        }
    }
`

const newMutator = gql`
    mutation($name: String!) {
        createDestination(name: $name) {
            destination {
                id
            }
        }
    }
`

const deleteMutator = gql`
    mutation removeDeviceMutation($ids: [String!], $allRecords: Boolean, $filters: String) {
        removeDevice(ids: $ids, allRecords: $allRecords, filters: $filters) {
            destintion {
                id
            }
        }
    }
`

const unitQuery = `
    destination(id: $id) {
        id
        name
    }
`

const DestinationTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allDestinations'), editMutator, newMutator, deleteMutator, unitQuery}

class DestinationTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "DestinationTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, DestinationTableCreatorQueries, new DefaultClickStrategy(), new HideDeletionDisplayStrategy())
        tableCreator.setInitialSortField('name', 'desc')
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'name',
                new DataMapper("name"),
                new f.FilterDescription(new f.TextFilter("name")),
                {label: 'Name'}
            )
        ])

        return tableCreator
    }
    
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(DestinationTableCreator)

export {
    DestinationTableCreator,
    DestinationTableCreatorQueries
}
